<template>
<div>
    <div class="card shadow">
        <div class="card-header bg-transparent">
            <div>
                <h3 class="mb-0">
                    {{ $tc('message.patients', 2) }}
                </h3>
            </div>
        </div>
        <div class="card-body p-0" v-if="can || hasAssistante">
            <b-container fluid class="p-0">
                <!-- User Interface controls -->
                <b-row>
                    <b-col lg="8" class="my-1">
                        <b-form-group label="Rechercher un patient" label-for="filter-input" label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0">
                            <b-input-group size="sm">
                                <b-form-input id="filter-input"  variant="primary" v-model="filter" type="search" placeholder="Saisiser pour rechercher"></b-form-input>

                                <b-input-group-append>
                                    <b-button  variant="primary" :disabled="!filter" @click="filter = ''">X</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" class="my-1">
                        <b-form-group label="Sort" label-for="sort-by-select" label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0" v-slot="{ ariaDescribedby }">
                            <b-input-group size="sm" >
                                <b-form-select id="sort-by-select" v-model="sortBy" :options="sortOptions" :aria-describedby="ariaDescribedby" class="w-75">
                                    <template #first>
                                        <option value="">--------</option>
                                    </template>
                                </b-form-select>

                                <b-form-select variant="primary" v-model="sortDesc" :disabled="!sortBy" :aria-describedby="ariaDescribedby" size="sm" class="w-25">
                                    <option :value="false">Asc</option>
                                    <option :value="true">Desc</option>
                                </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="6" md="4" class="my-1">
                        <b-form-group label="Médecin" label-for="per-page-select" label-cols-sm="6" label-cols-md="4" label-cols-lg="3" label-align-sm="right" label-size="sm" class="mb-0">
                            <b-form-select id="per-page-select" v-model="perDoctor" :options="mDoctors" size="sm"></b-form-select>
                        </b-form-group> 
                    </b-col>
                    <b-col sm="5" md="4" class="my-1">
                        <b-form-group label="Par page" label-for="per-page-select" label-cols-sm="6" label-cols-md="4" label-cols-lg="3" label-align-sm="right" label-size="sm" class="mb-0">
                            <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4" class="my-1 p-0">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>

                <!-- Main table element  -->
            <div class="table-responsive">
                <b-table :items="items" :fields="fields" :per-page="perPage" :filter="filter" :filter-included-fields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" stacked="md" show-empty small @filtered="onFiltered">
                    <template #cell(name)="row">
                        
                        {{ row.value.first }} {{ row.value.last }}
                    </template>
                    

                    <template #cell(actions)="row">
                        <b-button variant="success" size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                            Détails patient
                         </b-button>
                        <b-button  size="sm" @click="row.toggleDetails" v-if="row.item.doctors.length>0">
                            {{ row.detailsShowing ? 'Fermé' : 'Affiché' }} Médecin
                        </b-button>  
                        <b-button v-else size="sm" @click="row.toggleDetails" variant="danger" >
                            {{ row.detailsShowing ? 'Fermé ' : 'Ajouter Médecin' }} 
                        </b-button>
                    </template>

                    <template #row-details="row">
                         
                                <div sm="12" md="12" class="my-1">
                                <ol>
                                    <li v-for="(value, key) in row.item.doctors" :key="key">
                                        <div class="row"><div class="col-6">{{ value.nom }} </div><div class="col-2">{{ value.phone }}</div> <div class="col-3">{{ value.email }}</div> <div class="col-1"><b-button @click="removeReferent(value,key)" size="sm" variant="outline-danger">x</b-button></div></div>
                                    </li>
                                </ol>
                                </div>
                                <div  class="my-1">
                                    <b-form-group label="Affecter un médecin réferent" label-for="filter-input" label-cols-sm="3" label-align-sm="left" label-size="sm" class="mb-0">
                                        <b-input-group size="sm">
                                            <b-form-select  id="per-page-select" v-model="medecinToAdd" :options="mDoctors" size="sm"></b-form-select>
                                            <b-input-group-append>
                                                <b-button  variant="primary" @click="onAddReferent(row.item)">Ajouter</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group> 
                                 </div>
                       

                    </template> 
                </b-table>  
            </div>
          
                <!-- Info modal -->
                <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
                    <ul v-for="(item,key) in infoModal.content" :key="key">
                        <li v-if="!noDisplay.includes(key)"><b>{{ key }}</b> : <span>{{item}}</span></li>
                    </ul>                 
                </b-modal>
            </b-container>
        </div>
    </div>

</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import moment from 'moment';
import _ from 'lodash';

export default {
    name: "Patients",

    computed: {
        ...mapGetters(["patients", "count",
            'hasAdminRole',
            "controlDoctors",
            "controlDoctors",
            'hasGestionnaireRole',
            'hasMedecinControleRole',
            'hasPatientRole',
            'hasSouscripteurRole',
            'hasAssistante'
        ]),

        can: function () {
            return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
        },
        sortOptions() {
            // Create an options list from our fields
            return this.fields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    }
                })
        },

        // totalRows: function () {
        //     return this.count;
        // },

        mDoctors: function () {
            this.totalRows=this.count;
            let dArray = [
                { value: null, text:"Tous les Médecins" }
            ];

            _.forEach(_.orderBy(this.controlDoctors, ['created_at'], ['desc']), function (doctor) {
                let d = {};
                if ((typeof doctor.user == 'object') && (!_.isNull(doctor.user))) {
                    let prenom = doctor.user.prenom != null ? doctor.user.prenom : "";
                    prenom = prenom.toLowerCase();
                    d.text = (doctor.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    d.value = doctor.user.id;

                    if (d.text.length > 0) {
                        dArray.push(d);
                    }
                }

            });
            return dArray;
        },
    },

    data() {
        return {
            items:[],
            fields: [{
                    key: 'nom',
                    label: 'name',
                    sortable: true,
                    sortDirection: 'desc'
                },
                {
                    key: 'telephone',
                    label: 'telephone',
                    sortable: true,
                    class: 'text-center'
                },
                {
                    key: 'isActive',
                    label: 'Est suivi',
                    formatter: (value, key, item) => {
                        return value ? 'Oui' : 'Non'
                    },
                    sortable: true,
                    sortByFormatted: true,
                    filterByFormatted: true
                },
                {
                    key: 'actions',
                    label: 'Actions'
                }
            ],
            totalRows: 1,
            mpatients: [],
            currentPage: 1,
            medecinToAdd:{},
            perPage: 5,
            perDoctor: null,
            pageOptions: [5, 10, 15, {
                value: 100,
                text: "Show a lot"
            }],
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            noDisplay:["doctors","fileSlug","id","isActive","slug","_cellVariants","_showDetails"],
            infoModal: {
                id: 'info-modal',
                title: '',
                content: null
            }
        }
    },


    watch: {
        filter: async function(newValue){
            await this.getSearchPatient(newValue)
        },

        perPage: async function(newValue){
            if(this.perDoctor===null){
                this.getFirstPatients(newValue);
                
            }
                
            else{
                await this.getCountPatientsDoctor(this.perDoctor, newValue);
                this.totalRows=this.count;
                await this.getFirstPatientsDoctor(this.perDoctor, newValue);

            }
                
            
        },

        currentPage: async function(newValue){
            // console.log("current");
            // console.log(this.currentPage);
            // console.log((newValue-1) * this.perPage);
            if(this.perDoctor===null){
                if(this.filter===null)
                    this.getNextPatients(this.perPage, newValue);
                // else
                //     this.items = this.mpatients.slice((newValue - 1) * this.perPage, this.perPage);
            }
                
            else{
                if(this.filter===null)
                    await this.getNextPatientsDoctor(this.perDoctor, this.perPage, newValue);
                else
                    this.items=this.mpatients.slice((newValue-1)*this.perPage, this.perPage);
            }
                
            // console.log(this.patients);
            // this.items = pArray;
        },
        
        perDoctor: async function(newValue){
            // console.log("doctor");
            // console.log(newValue);
            if(newValue == null){
                this.items = this.mpatients;
            }else{
                await this.getCountPatientsDoctor(this.perDoctor, newValue);
                this.totalRows=this.count;
                await this.getFirstPatientsDoctor(newValue, this.perPage);
                // this.totalRows=this.patients.length;
                // this.items = this.filterByProperty(this.mpatients,'id',newValue);
            }
            
        },
        patients: function(){
            
            let pArray = [];
            _.forEach(this.patients, function (patient) {
                    let p = {};
                     //let patient = item.patients ;
                    if (typeof patient.user == 'object' && patient.user!==null) {

                        let prenom = patient.user.prenom ? patient.user.prenom : '';
                        prenom = prenom.toLowerCase();
                        p.nom = (patient.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        p.dossier = patient.dossier.numero_dossier
                        p.email = patient.user.email;
                        p.telephone = patient.user.telephone;
                        p.age = moment().year() - moment(patient.date_de_naissance).year();
                        p.sexe = patient.sexe;
                        p.nationalite = patient.user.nationalite;
                        p.ville = patient.user.ville;
                        p.pays = patient.user.pays;
                        p.date = moment(patient.user.date_de_naissance).format('DD-MM-YYYY');
                        p.id = patient.user.id;
                        p.slug = patient.user.slug;
                        p.adresse = patient.user.adresse;
                        p.fileSlug = patient.dossier.slug;

                    }
                    p.doctors = [];
                    if (!_.isUndefined(patient.medecin_referent) && patient.medecin_referent.length > 0) {
                        _.forEach(patient.medecin_referent, function (doctor) {
                            let d = {};
                            if ((!_.isNull(doctor.medecin_controles)) && (typeof doctor.medecin_controles.user == 'object') && (!_.isNull(doctor.medecin_controles.user))) {
                                let prenom = doctor.medecin_controles.user.prenom != null ? doctor.medecin_controles.user.prenom : "";
                                prenom = prenom.toLowerCase();
                                d.nom = (doctor.medecin_controles.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                                d.id = doctor.medecin_controles.user.id;
                                d.phone = doctor.medecin_controles.user.telephone
                                d.email = doctor.medecin_controles.user.email
                                d.medecin_referent_id = doctor.id
                                if (d.nom.length > 0) {
                                    p.doctors.push(d);
                                }
                            }

                        });

                    }

                    if(p.doctors.length>0){
                        p.isActive = true;
                    }
                    else{
                        p.isActive = false;
                        p._cellVariants = { nom: 'danger', isActive: 'warning' }
                    }
                    let hasPatient = _.filter(pArray, function (item) {
                        if (item.dossier == p.dossier)
                            return p;
                    })
                    if (_.isEmpty(hasPatient)) {
                        pArray.push(p);
                    }
            });
          
            this.items = pArray;
            this.mpatients = pArray;

            // console.log("items");
            // console.log(this.items);

        }      
    },

    methods: {
         filterByProperty:function(array, prop, value){
            var filtered = [];
            for(var i = 0; i < array.length; i++){

                var obj = array[i];

                    if(typeof(obj['doctors'] == "object") && obj['doctors'].length > 0){                     
                        var item = obj['doctors'];  
                            
                        for(var j = 0; j < item.length; j++) {
                            // console.log(item[j])
                            if(item[j][prop] == value){
                                filtered.push(obj);
                            }
                        }                 

                    }
            }    

            return filtered;

        },
        onPatientClick(params) {
            this.$router.push({
                name: 'patient',
                params: {
                    patient: params.row.slug
                }
            });
        },

        getPatients() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getPatientsWithMedecinControle', {
                args: args
            });
        },

         getFirstPatients(limit) {
            let args = {
                limit: limit
            };

            this.$store.dispatch('getFirstPatientsWithMedecinControle', {
                args: args
            });
        },

        getNextPatients(limit, page) {
            let args = {
                limit: limit,
                page: page
            };

            this.$store.dispatch('getNextPatientsWithMedecinControle', {
                args: args
            });
        },


        getCountPatients() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getCountPatientsWithMedecinControle', {
                args: args
            });
        },

        async getCountPatientsDoctor(value) {
                // console.log("juste pour vérifier");
                let args = {
                    doctor: value,
                };

                await this.$store.dispatch("getCountPatientsDoctor", {
                    args : args
                });
        },

        async getSearchPatient(value) {
                // console.log("juste pour vérifier");
                let args = {
                    patient: value
                };

                await this.$store.dispatch("getSearchPatient", {
                    args : args
                });
        },

        async getFirstPatientsDoctor(value, limit) {
                // console.log("juste pour vérifier");
                let args = {
                    doctor: value,
                    limit: limit
                };

                await this.$store.dispatch("getFirstPatientsDoctor", {
                    args : args
                });
        },

        async getNextPatientsDoctor(value, limit, page) {
                // console.log("juste pour vérifier");
                let args = {
                    doctor: value,
                    limit: limit,
                    page: page
                };

                await this.$store.dispatch("getNextPatientsDoctor", {
                    args : args
                });
        },

        // get100Patients() {
        //     let args = {
        //         offset: this.offset,
        //         limit: this.limit
        //     };

        //     this.$store.dispatch('get100PatientsWithMedecinControle', {
        //         args: args
        //     });
        // },

        info(item, index, button) {
            this.infoModal.title = `Patient: ${item.nom}`;
            this.infoModal.content = item;
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        resetInfoModal() {
            this.infoModal.title = ''
            this.infoModal.content = ''
        },
        onFiltered(filteredItems) {
            // console.log("ici??");
            // console.log(filteredItems);
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        onAddReferent(item) {
				const args = {};
                let self = this;
                args.medecin_control_id = [{'id':this.medecinToAdd}];
                args.patient_id = item.id;

                
					const successMessage = this.$i18n.t('message.followedUpCreated');
					const errorMessages = {
						generic: this.$i18n.t('message.genericError'),
						error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
					};
          
					const payload = { args, errorMessages, successMessage };  
                   
					this.$store.dispatch("addDoctorToPatient", payload).then(() => {
                         let d = {};
                         for(var i = 0; i < this.controlDoctors.length; i++){
                            if(item.user_id == self.medecinToAdd){
                                let prenom = item.user.prenom != null ? item.user.prenom : "";
                                d.text = (item.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                                d.value = item.user.id;
                                if (d.text.length > 0) {
                                    this.mDoctors.push(d);
                                }
                                // console.log(d)
                                return;
                            }
                         }
                    });  
        },
        removeReferent(item,key){
            //console.log(item)

            let args = {
                slug: item.medecin_referent_id
            };
  
            let successMessage = this.$i18n.t('supprimé');
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.error')
            };
            
            this.$store.dispatch('deleteMedecinPatient', {
                args,
                successMessage,
                errorMessages
            }).then(()=>{
                this.getFirstPatients(5);
               // window.location.reload();
            }); 

        },
        getDoctors() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getControlDoctors', {
                args: args
            });
        },
    },

    mounted() {
       // this.getInstitutions();
       this.getCountPatients();
        this.getFirstPatients(5);
        this.getDoctors();
        
    }
}
</script>

<style scoped>

</style>
